// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".JKPdI{position:relative;margin:40px 0}.JKPdI>iframe{overflow:hidden;width:1px;min-width:100%;border:0;background:0}.JKPdI.DxFiS:after{display:block;padding-bottom:56.25%;content:\"\"}.JKPdI.DxFiS>iframe{height:100%!important}.JKPdI.DxFiS>iframe,._8ly0L{position:absolute;top:0;left:0;width:100%}._8ly0L{z-index:1;display:flex;height:100%;align-items:center;justify-content:center;background:#f4f4f4}@media screen and (min-width:768px){._8ly0L{background:#fcfcfc}}[data-a11y] .JKPdI{margin-top:48px;margin-bottom:48px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boxEmbed": "JKPdI",
	"youtube": "DxFiS",
	"loader": "_8ly0L"
};
module.exports = ___CSS_LOADER_EXPORT___;
